module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"label":"Country"},"es":{"label":"País"},"fr":{"label":"Pays"},"it":{"label":"Paese"},"pt":{"label":"País"},"pl":{"label":"Kraj"}}')
  delete Component.options._Ctor
}
